module.exports = __webpack_public_path__ + "img/cyber-monday-2023.01753183.png";